export default __webpack_public_path__ + "static/media/0x3f6b3595ecf70735d3f48d69b09c4e4506db3f47.5e78e8dd.webp";